module.exports = __webpack_public_path__ + "img/logo_color_stage.6390b318.svg";